require.register("app/product/show/LogsTab", function(exports, require, module){
  $0
  
});

